import React from "react";
export const load = (stroke) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 4.762 6.35"
    >
        <g id="layer1" transform="translate(-0.821 0.001)">
            <path
                id="path1037-8-8-3-5"
                d="M5.479,2.68c.01.316-.415.61-1.115.771a5.51,5.51,0,0,1-2.275.009C1.382,3.3.943,3.013.937,2.7M5.479,5.337c.01.316-.415.61-1.115.771a5.51,5.51,0,0,1-2.275.009C1.382,5.961.943,5.67.937,5.354m4.542-.9c.01.316-.415.61-1.115.771a5.51,5.51,0,0,1-2.275.009C1.382,5.075.943,4.784.937,4.469m4.542-.9c.01.316-.415.61-1.115.771a5.51,5.51,0,0,1-2.275.009C1.382,4.189.943,3.9.937,3.583M5.479,1.794c.01.316-.415.61-1.115.771a5.51,5.51,0,0,1-2.275.009C1.382,2.417.943,2.127.937,1.811M5.485.98c0,.488-1.022.883-2.283.883S.919,1.468.919.98,1.941.1,3.2.1s2.283.4,2.283.883M.939,1.128v4.26h0c.023.479,1.031.863,2.267.863s2.244-.384,2.267-.863h0V1.128H5.451c-.074.261-.5.492-1.149.619a4.96,4.96,0,0,1-3.059-.31.591.591,0,0,1-.273-.309Z"
                fill="none"
                stroke={stroke}
                strokeLinejoin="round"
                strokeWidth="0.196"
            />
        </g>
    </svg>
);
